import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { INotesInfo } from '../../models/ProspectModel';
import { CommonMethodService } from '../../common-method.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-add-priority-notes-shared',
    templateUrl: './add-priority-notes-shared.component.html',
    styleUrls: ['./add-priority-notes-shared.component.scss'],
    standalone: false
})
export class AddPriorityNotesSharedComponent implements OnInit {
  priorityNotesForm: FormGroup;
  fieldValues: Object;
  public mode: string = 'CheckBox';
  @Input() unitList;
  @Input() facilityId;
  @Output() isPriorityNotesSaved: EventEmitter<any> = new EventEmitter<any>();
  loaderIcon: Promise<boolean>;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  priorityNotesList: any = [];
  today: string;

  constructor(private formBuilder: FormBuilder,
    private prospectsService: ProspectService,
    private commonMethodService: CommonMethodService,
    private toaster: ToastrService
  ) {
    this.fieldValues = { dataSource: this.unitList, text: "UnitNumber", value: "UnitId" };
  }

  ngOnInit(): void {
    this.priorityNotesForm = this.formBuilder.group({
      UnitNumber: [''],
      PriorityNotes: [],
      PriorityNote: [true],
      keepActiveDate: []
    });
    const datePipe: DatePipe = new DatePipe('en');
    this.today = datePipe.transform(new Date(), 'MM/dd/yyyy');
  }

  getPriority(event) {
    const [selectedUnitId, unitType] = event.target.value.split('-');
    const parsedUnitId = parseInt(selectedUnitId, 10);
    var selectedUnit = this.priorityNotesList?.find(ele => ele.UnitId == parsedUnitId && (unitType == 'Inquiry' ? ele.InquiryNumber > 0 : (unitType == "Lease" ? ele.LeaseNo > 0 : ele.ReservationNumber > 0)));
    this.priorityNotesForm.patchValue(
      {
        UnitNo: event.target.value,
        PriorityNote: true,
        PriorityNotes: selectedUnit?.Text ?? '',
        keepActiveDate: selectedUnit?.PriorityNoteExpiry ? this.commonMethodService.getTimeZoneOffSetDate(selectedUnit.PriorityNoteExpiry) : ''
      });
  }

  disablePriorityNoteSave(): boolean {
    const { UnitNumber, PriorityNote, PriorityNotes, keepActiveDate } = this.priorityNotesForm.value;

    if (!UnitNumber || !PriorityNotes) return true;
    let unitId = UnitNumber.includes('-') ? UnitNumber.split('-')[0] : UnitNumber;
    let selectedUnit = this.unitList.find(ele => ele.UnitId == unitId);
    if(selectedUnit.ReservationNumber == 0 && selectedUnit.InquiryNumber == 0 && selectedUnit.LeaseNumber == 0) return true;

    const existingPriorityNote = this.priorityNotesList.find(x => x.UnitId == unitId);
    const selectedDate = (this.commonMethodService.getDateTimeWithoutTimeForApi(keepActiveDate))?.split('T')[0];
    const previousDate = existingPriorityNote && existingPriorityNote.PriorityNoteExpiry ?   existingPriorityNote.PriorityNoteExpiry?.split('T')[0] : "";
    if (!existingPriorityNote && !selectedDate && !previousDate) return false;
    const isSameNote = existingPriorityNote && existingPriorityNote.Text === PriorityNotes && existingPriorityNote.PriorityNote === PriorityNote && selectedDate === previousDate;
    const isInvalidNote = PriorityNote && !PriorityNotes || !PriorityNotes;
    return isSameNote || isInvalidNote;
  }

  updatePriorityNotes() { 
    let unitType = this.priorityNotesForm.value.UnitNumber.includes('-') ? this.priorityNotesForm.value.UnitNumber.split('-')[0] : this.priorityNotesForm.value.UnitNumber;
    let selectedUnit = this.unitList.find(ele => ele.UnitId == unitType);
    var editedObj = {
      NotesId: this.priorityNotesForm.value.PriorityNote ? 0 : this.priorityNotesList.find(x => x.UnitId == selectedUnit.UnitId).NotesId,
      LeaseNo: selectedUnit.LeaseNumber > 0 ? selectedUnit.LeaseNumber : null,
      FacilityId: selectedUnit.LeaseNumber > 0 ? selectedUnit.FacilityId : null,
      ReservationNumber: selectedUnit.ReservationNumber > 0 ? selectedUnit.ReservationNumber : null,
      ReservationFacilityId: selectedUnit.ReservationNumber > 0 ? selectedUnit.FacilityId : null,
      InquiryNumber: selectedUnit.InquiryNumber > 0 ? selectedUnit.InquiryNumber : null,
      InquiryFacilityId: selectedUnit.InquiryNumber > 0 ? selectedUnit.FacilityId : null,
      InquiryNotesFacilityId: null,
      FollowUpId: null,
      NotesDate: new Date(),
      Text: this.priorityNotesForm.value.PriorityNotes,
      CustomerNotes: false,
      PriorityNote: this.priorityNotesForm.value.PriorityNote,
      CollectionCall: false,
      PaymentReceiptId: null,
      DisplayAlert: false,
      UnitNo: selectedUnit.UnitNumber,
      TransactionTypeId: 0,
      PriorityId: 0,
      PriorityNoteExpiry: this.commonMethodService.getDateTimeWithoutTimeForApi(this.priorityNotesForm.value.keepActiveDate),
      isNotesUpdatedOrDeleted: !this.priorityNotesForm.value.PriorityNote && this.priorityNotesList.find(x => x.UnitId == selectedUnit.UnitId).NotesId != 0,
      TenantId : selectedUnit.TenantId
    };

    this.prospectsService.SaveNotes(editedObj).subscribe((response: any) => {
      if (response.Success) {
        if (!editedObj.PriorityNote) {
          this.toaster.success('Priority Notes Removed Successfully', 'Success', this.toasterConfig);
        } else {
          this.toaster.success('Priority Notes Saved Successfully', 'Success', this.toasterConfig);
        }
      } else {
        this.toaster.error('Failed to Save Create Priority Notes', 'Failed!', this.toasterConfig);
      }
      this.isPriorityNotesSaved.emit(true);
    }, err => {
      this.toaster.error('Failed to Save Create Priority Notes', 'Failed!', this.toasterConfig);
    });
  }

  onclickCancel() {
    this.priorityNotesForm.reset();
    this.isPriorityNotesSaved.emit(false);
  }

  getAllNotes(tenantId: number) {
    let UnitId;
    if (tenantId == 0) {
      let selectedUnit = this.unitList[0];
      if (selectedUnit) {
        const status = selectedUnit.ReservationNumber > 0 ? 'Reservation' : selectedUnit.LeaseNumber > 0 ? 'Lease' : 'Inquiry';
        UnitId = `${selectedUnit.UnitId}-${status}`;
      }
      this.priorityNotesForm.patchValue(
        {
          UnitNumber: UnitId,
          PriorityNote: selectedUnit?.PriorityNote ?? true,
          PriorityNotes: selectedUnit?.Text ?? '',
          keepActiveDate: selectedUnit?.PriorityNoteExpiry ?? ''
        });
      return;
    }
    this.loaderIcon = Promise.resolve(true);
    this.prospectsService.getAllNotes(tenantId).subscribe((response: INotesInfo[]) => {
      this.priorityNotesList = response?.filter(x => x?.PriorityNote) || [];

      let selectedUnit = this.priorityNotesList.length > 0 ? this.priorityNotesList[0] : this.unitList[0];
      if (selectedUnit) {
          const status = selectedUnit.ReservationNumber > 0 ? 'Reservation' : selectedUnit.InquiryNumber > 0 ? 'Inquiry' : 'Lease';   
          UnitId = `${selectedUnit.UnitId}-${status}`;
      }
      this.priorityNotesForm.patchValue(
      {
          UnitNumber: UnitId,
          PriorityNote: selectedUnit?.PriorityNote ?? true,
          PriorityNotes: selectedUnit?.Text ?? '',
          keepActiveDate: selectedUnit?.PriorityNoteExpiry ? this.commonMethodService.getTimeZoneOffSetDate(selectedUnit.PriorityNoteExpiry) : ''
      });
      this.loaderIcon = Promise.resolve(false);
    });
  }
}
